import { ca } from '@cian/analytics';
import { IPromoOffer } from '../../types/promoOffersSelection';

export const trackBlockShow = (offers: IPromoOffer[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'promo_offers',
    products: offers.map(({ offerId, promoInfo }) => ({
      id: offerId,
      offerType: 'promo',
      extra: {
        is_price_with_discount: promoInfo.promoType === 'discount',
      },
    })),
  });
};

type TClickType = 'to_offers' | 'to_promo' | 'to_jk' | 'to_listing' | 'to_listing_modal' | 'to_promo_with_discount';

interface IBlockClickParams {
  offersIds: number[];
  clickType: TClickType;
}

export const trackBlockClick = ({ offersIds, clickType }: IBlockClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'click_sopr',
    label: 'promo_offers',
    products: offersIds.map(id => ({
      id,
      offerType: 'promo',
      extra: {
        clickType,
      },
    })),
  });
};
